import { create } from 'zustand';
import { AxiosError } from 'axios';

const MAX_LIMIT = 3;

export type ToastVariant = 'success' | 'warning' | 'error' | 'info';

export type ToastProps = {
	id: string;
	variant: ToastVariant;
	content: React.ReactNode | AxiosError | string;
};

type UseToastStoreProps = {
	toasts: ToastProps[];
	addToast: (toast: ToastProps) => void;
	removeToast: (id: string) => void;
};

export const useToastStore = create<UseToastStoreProps>((set) => ({
	toasts: [] as ToastProps[],
	addToast: (toast) => set((state) => ({ toasts: [toast, ...state.toasts].slice(0, MAX_LIMIT) })),
	removeToast: (id) => set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) })),
}))